<template>
	<div class="h-full">
		<div class="flex-1">
			<slot />
		</div>
		<EmojiPickerDialog />
		<ModalsContainer />
	</div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { ModalsContainer } from 'vue-final-modal';

@Component({
	components: {
		ModalsContainer
	}
})
export default class RespondantApp extends Vue {
	mounted(): void {

	}
}
</script>

<style lang="scss">
.hdl-app {
	@apply flex flex-row items-start w-full h-full;
}
</style>
